<template>
  <div class="page not-found text-center d-flex flex-column fill-height align-center justify-center">
    <v-container class="text-center" style="margin-bottom: 25%">
        <h2 class="mb-4 text-center">الصفحة غير موجودة</h2>
        <v-btn fill depressed to="/">رجوع للرئيسية</v-btn>
    </v-container>
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  computed: {
    
  }
}
</script>